import ThumbBoard from './thumb_board';

export default ThumbBoard;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/index.js
 **/